import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { XMarkIcon, BellIcon } from "@heroicons/react/24/outline";
import { useNotifications } from "../../../context/NotificationContext";
import { useLanguage } from "../../../context/LanguageContext";

export default function NotificationToast() {
  const { t } = useLanguage();
  const { toast, clearToast } = useNotifications();

  // Auto-dismiss after 4s
  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(clearToast, 4000);
    return () => clearTimeout(id);
  }, [toast, clearToast]);

  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          key={toast.id}
          initial={{ opacity: 0, y: 40, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
          className="fixed bottom-6 end-6 z-[9999] w-80 bg-white rounded-2xl shadow-2xl border border-gray-200 p-4 flex items-start gap-3"
        >
          <div className="p-2 bg-[#b2d12e]/15 rounded-lg flex-shrink-0">
            <BellIcon className="w-4 h-4 text-[#b2d12e]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-[#b2d12e] uppercase tracking-wide mb-0.5">{t("notifications.newToast")}</p>
            <p className="text-sm text-gray-800 leading-snug line-clamp-2">{toast.message}</p>
          </div>
          <button onClick={clearToast} className="text-gray-400 hover:text-gray-600 flex-shrink-0">
            <XMarkIcon className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
